/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Watch_LeadInputs */

const en_features_watch_lead = /** @type {(inputs: Features_Watch_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your next client on your wrist.`)
};

const pl_features_watch_lead = /** @type {(inputs: Features_Watch_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Następny klient na nadgarstku.`)
};

/**
* | output |
* | --- |
* | "Your next client on your wrist." |
*
* @param {Features_Watch_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_watch_lead = /** @type {((inputs?: Features_Watch_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Watch_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_watch_lead(inputs)
	return en_features_watch_lead(inputs)
});